import { Button, ErrorState, Loading } from '@dec/shared';
import { BtnGroup, BtnToolbar } from '@dec/shared';
import * as icon from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useTaxReturn } from '../../hooks/useTaxReturn';

import { TaxReturnContent } from './components/taxReturnContent';

export const ViewTaxReturnPage = () => {
  const { t } = useTranslation();
  const { id } = useParams();

  const { data, isLoading, error } = useTaxReturn(id!);

  if (isLoading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorState />;
  }

  const handlePrint = () => {
    alert('opcion de imprimir');
  };

  return (
    <>
      <BtnToolbar>
        <BtnGroup>
          <></>
        </BtnGroup>
        <BtnGroup>
          <Button
            icon={icon.Printer}
            text={t('common.label.print')}
            variant="primary"
            onClick={() => handlePrint()}
          />
        </BtnGroup>
      </BtnToolbar>
      {/* componente responsable de mostrar el contenido de la declaración */}
      <TaxReturnContent content={data!} />
    </>
  );
};
